import { createLink } from '@tanstack/react-router'
import { IconWeight } from 'phosphor-react'
import { AnchorHTMLAttributes } from 'react'

import { Icon, IconTypes, cn } from '@hap/components'

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  icon: IconTypes
  iconWeight?: IconWeight
  iconClassName?: string
}

function BaseNavLink({
  className,
  children,
  icon,
  iconWeight,
  iconClassName,
  ...props
}: Props) {
  // const nextReturnTo =
  //   search.returnTo ||
  //   (typeof window !== 'undefined'
  //     ? `${window.location.pathname}${window.location.search}${window.location.hash}`
  //     : pathname)

  return (
    <a
      {...props}
      // data-status={isActive ? 'active' : undefined}
      className="[&_svg]:stroke-foreground hover:bg-accent text-foreground/80 data-[status=active]:text-foreground data-[status=active]:bg-accent group-hover:[&_svg]:stroke-new-primary group relative flex w-full items-center rounded-md p-2 px-4 text-left"
    >
      {!!icon && (
        <Icon
          name={icon}
          size={16}
          className={cn('mr-2 shrink-0 opacity-80', iconClassName)}
          weight={iconWeight}
        />
      )}
      <span className="w-0 shrink grow truncate">{children}</span>
    </a>
  )
}

export const NavLink = createLink(BaseNavLink)
